import React, { useState, useEffect, useContext } from 'react';
import {Stack} from '@shopify/polaris';
import EditNodes from './EditNodes'
import { useDragLayer } from 'react-dnd'
import {CourseTreeContext} from '../contexts/CourseTree';

export default function EditCourseTreeForm(props) {
  const [courseTree] = useContext(CourseTreeContext)

  const { isDragging } = useDragLayer(
    monitor => {
      return {
        isDragging: monitor.isDragging()
      }
    }
  )

  return (<div className={isDragging ? 'dragging' : ''}>
      {
        courseTree.child_nodes.map((child_node, index) => {
          return <EditNodes key={child_node.id} item={child_node}
            prevNode={index > 0 ? courseTree.child_nodes[index - 1] : null}
            nextNode={courseTree.child_nodes[index + 1]}
          />
        })
      }
  </div>)
}
